import { render, staticRenderFns } from "./TableAndGraph.vue?vue&type=template&id=4b2a43da&scoped=true"
import script from "./TableAndGraph.vue?vue&type=script&lang=js"
export * from "./TableAndGraph.vue?vue&type=script&lang=js"
import style0 from "./TableAndGraph.vue?vue&type=style&index=0&id=4b2a43da&prod&scoped=true&lang=scss"
import style1 from "./TableAndGraph.vue?vue&type=style&index=1&id=4b2a43da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2a43da",
  null
  
)

export default component.exports